import { useEffect, useState } from "react";
import { Eyebrow, RoleSwitcher, roleKeys, type RoleKey } from "@appcaire/ui";
import { brandHomeCopy } from "./brandHomeCopy";
import type { LandingLocale } from "../landingCopy";
import {
  homeSectionClass,
  homeSectionHeadClass,
  homeSectionTitleClass,
} from "./HomeParts";

const HASH_PREFIX = "#for=";

function roleFromHash(): RoleKey | null {
  if (typeof window === "undefined") return null;
  const value = window.location.hash.startsWith(HASH_PREFIX)
    ? window.location.hash.slice(HASH_PREFIX.length)
    : "";
  return (roleKeys as string[]).includes(value) ? (value as RoleKey) : null;
}

/** "Jag är…": what Caire means per role (1b). State lives in #for=<role>. */
export function RoleSection({ locale }: { locale: LandingLocale }) {
  const c = brandHomeCopy[locale].roles;
  const [role, setRole] = useState<RoleKey>("planerare");

  useEffect(() => {
    const sync = () => {
      const fromHash = roleFromHash();
      if (fromHash) setRole(fromHash);
    };
    sync();
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
  }, []);

  const change = (next: RoleKey) => {
    setRole(next);
    window.history.replaceState(
      { ...window.history.state },
      "",
      `${HASH_PREFIX}${next}`,
    );
  };

  return (
    <section
      className={homeSectionClass}
      id="for"
      aria-labelledby="roles-heading"
      data-home-section="roles"
    >
      <Eyebrow>{c.eyebrow}</Eyebrow>
      <h2 id="roles-heading" className={`${homeSectionTitleClass} mb-6`}>
        {c.title}
      </h2>
      <RoleSwitcher
        items={c.items}
        value={role}
        onChange={change}
        label={c.groupLabel}
      />
    </section>
  );
}
